export interface MappingOptions {
    containerMappingType: "UNFILTERED" | "FILTERED" | "NONE"
    parameterMappingType: "UNFILTERED" | "FILTERED" | "NONE"
    valueMappingType: "ALL" | "SELECTABLE" | "SELECTED"
    pricingMappingType: "ALL" | "NONE" | "ONLY"
    pricingDisplayType: "ABSOLUTE" | "SURCHARGE"
    executionResultSource: "CONFIGURATION" | "CONTAINER"
    configurationTreeMappingType: "INTERNAL" | "LINKED" | "GUI" | "CALCULATION"
    translationMappingType: "KEYS" | "TRANSLATIONS" | "TRANSLATION_CONTEXT"
    mappingProfile:
        | "MINIMUM_CONTENT_MAPPING"
        | "MEDIUM_CONTENT_MAPPING"
        | "MAXIMUM_CONTENT_MAPPING"
        | string
}

export enum GuiType {
    DefaultUI = "default",
    InternalUI = "internal"
}

export interface UserSettings {
    mappingOptions: MappingOptions
    gui: GuiType
    mediaLink: (id: string) => string
}
